<template>
  <div>
    <doc-title :text="post.title" v-if="post"></doc-title>
    <doc-meta :text="post.excerpt" :image="post.picture" v-if="post"></doc-meta>

    <div class="card" v-if="post">
      <div class="card-body">
        <img :src="post.picture" width="450" height="100%" class="w-100 w-md-50 float-left mr-4 mb-3 rounded" v-if="post.picture">

        <h1 class="font-weight-bold">
          <a :href="post.url">
            {{ post.title }}
          </a>
        </h1>

        <h5>
          {{ post.excerpt }}
        </h5>

        <a :href="post.url" target="_blank" class="btn btn-primary btn-lg mt-3">
          Weiter lesen
        </a>

        <div class="d-flex mt-4">
          <router-link :to="'/sources/' + post.source.id" class="text-muted">
            {{ post.source.name }}
          </router-link>
          <span class="mx-2 text-primary">&bull;</span>
          <router-link :to="'/posts/' + post.slug" class="text-muted">
            <timeago :datetime="post.publishedAt"></timeago>
          </router-link>

          <favorite :post="post" class="ml-3" v-on:unfavorited="$emit('unfavorited', $event)"></favorite>
        </div>
      </div>
    </div>

    <div class="py-4 text-center">
      <ad :zone="131" class="s728x90"></ad>
    </div>

    <h3>
      Weitere Artikel, die dich interessieren könnten
    </h3>

    <list resource="posts" :per-page="5" :enable-pager="false"></list>
  </div>
</template>

<script>
  import DocTitle from '@/vues/helpers/doc-title.vue';
  import DocMeta from '@/vues/helpers/doc-meta.vue';
  import Favorite from './favorite.vue';
  import List from './list.vue';
  import Ad from '@/vues/helpers/ad.vue';

  export default {
    name: 'PostShow',
    components: { DocTitle, DocMeta, Favorite, List, Ad },
    data () {
      return {
        working: true,
        post: null
      };
    },
    async mounted () {
      const params = {
        imgOptions: JSON.stringify({
          width: 450
        })
      };

      const res = await this.$http.get('posts/' + this.$route.params.id, { params });
      this.post = res.body;
      this.working = false;

      document.querySelector('link[rel="amp"]').href = `https://www.jagdnews.de/amp/posts/${this.post.slug}`;
      document.querySelector('link[rel="amp"]').rel = 'amphtml';
    }
  };
</script>
